module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/people_without_interaction-e14a75713d2c98bb0bd6cdc2bba988e4.svg";